import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);
import condodetail from './condodetail.js'
import prizes from './prizes.js'



export default new Vuex.Store({
    modules: {
        condodetail,
        prizes
    }
})
